import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/styles'
import { List, Drawer, Box, Hidden } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'
import { SidebarButton } from './components'
import { SidebarItem } from '../../types'
import { getSidebarWidth } from '~/utils/themeHelpers'
import { MutualLogoWhite } from '~/assets/icons'

const useStyles = makeStyles({
  logoContainer: {
    height: mutualTheme.topbar.height
  },
  drawer: {
    backgroundColor: mutualTheme.sidebar.backgroundColor,
    width: getSidebarWidth(),
    [mutualTheme.breakpoints.down('md')]: {
      height: mutualTheme.topbar.height
    }
  },
  listItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
})

export type SidebarProps = {
  items: SidebarItem[]
}

export const Sidebar: React.FC<SidebarProps> = (props) => {
  const { items } = props
  const classes = useStyles()

  const itemsToRender = useMemo(() => {
    return items.map((item, index) => <SidebarButton key={index} to={item.path} onClick={item.onClick}>{item.icon}</SidebarButton>)
  }, [items])

  return (
    <Drawer variant='permanent' classes={{ paper: classes.drawer }}>
      <Box style={{ display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }} className={classes.logoContainer}>
        <MutualLogoWhite />
      </Box>
      <Hidden mdDown>
        <List>
          {itemsToRender}
        </List>
      </Hidden>
    </Drawer>
  )
}
